import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Button, Col, Container, Row } from "react-bootstrap";

const carouselImages = [
    {
        src: "./design.png",
        alt: "Modern Kitchen Design",
        caption: "Design Stunning Kitchens Instantly",
    },
    {
        src: "./insert_wall.png",
        alt: "Cabinet Manufacturing",
        caption: "Automatic Quotes for Dealers",
    },
    {
        src: "./cablist.png",
        alt: "Visual Kitchen Designer",
        caption: "Visualize, Customize, Sell",
    },
];

const CarouselContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 90vw;
    height: 60vh;
    margin: 0 auto;
    overflow: hidden;

    box-shadow: 0 4px 24px rgba(0,0,0,0.12);
    background: #222;
`;

const Slide = styled.div`
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 0.8s;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    &.active {
        opacity: 1;
        z-index: 1;
    }
`;

const Caption = styled.div`
    background: rgba(0,0,0,0.5);
    color: #fff;
    padding: 1.2rem 2rem;
    width: 100%;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 500;
`;

const Indicators = styled.div`
    position: absolute;
    bottom: 18px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 0.7rem;
`;

const Indicator = styled.span`
    display: block;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    opacity: 0.5;
    cursor: pointer;
    transition: opacity 0.3s, background 0.3s;
    &.active {
        opacity: 1;
        background: #ff9800;
    }
`;

function Carousel() {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            setCurrent((prev) => (prev + 1) % carouselImages.length);
        }, 3500);
        return () => clearTimeout(timer);
    }, [current]);

    return (
        <CarouselContainer>
            {carouselImages.map((img, idx) => (
                <Slide
                    key={idx}
                    className={idx === current ? "active" : ""}
                    style={{ backgroundImage: `url(${img.src})` }}
                >
                    <Caption>
                        <h2>{img.caption}</h2>
                    </Caption>
                </Slide>
            ))}
            <Indicators>
                {carouselImages.map((_, idx) => (
                    <Indicator
                        key={idx}
                        className={idx === current ? "active" : ""}
                        onClick={() => setCurrent(idx)}
                    />
                ))}
            </Indicators>
        </CarouselContainer>
    );
}

const LandingContainer = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(120deg, lightgray 0%, #e0e7ff 100%);
    padding: 0;
    box-sizing: border-box;
`;

const LandingHeader = styled.header`
    width: 100%;
    max-width: 90vw;
    margin: 2rem auto 0 auto;
    text-align: center;
    padding: 2rem 1rem 1rem 1rem;
    background: rgba(255,255,255,1);
    
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    h3 {
        font-size: 2.2rem;
        font-weight: 700;
        margin-bottom: 0.7rem;
        color: #222;
    }
    p {
        font-size: 1.2rem;
        color: #444;
        margin-bottom: 1.2rem;
    }
    .cta-button {
        display: inline-block;
        padding: 0.8rem 2rem;
        font-size: 1.1rem;
        font-weight: 600;
        color: #fff;
        background: #ff9800;
        border: none;
        
        text-decoration: none;
        box-shadow: 0 2px 8px rgba(0,0,0,0.10);
        transition: background 0.2s;
        &:hover {
            background: #fb8c00;
        }
    }
`;

const FeaturesSection = styled.section`
    width: 100%;
    max-width: 90vw;
    margin: 2rem auto;
    background: rgba(255,255,255,0.95);
    box-shadow: 0 2px 12px rgba(0,0,0,0.07);
    padding: 2rem 2.5rem;
    text-align: left;
    h2 {
        font-size: 1.7rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: #222;
    }
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        li {
            font-size: 1.15rem;
            margin-bottom: 0.7rem;
            color: #444;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
    }
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const LandingFooter = styled.footer`
    width: 100%;
    max-width: 900px;
    margin: 2rem auto 1rem auto;
    text-align: center;
    color: #888;
    font-size: 1rem;
    background: none;
`;

const FadeIn = styled.div`
    opacity: 0;
    animation: fadeIn 1.2s forwards;
    &.delay-1 { animation-delay: 0.5s; }
    &.delay-2 { animation-delay: 1s; }
    &.delay-3 { animation-delay: 1.5s; }
    @keyframes fadeIn {
        to { opacity: 1; }
    }
`;


export default function Home() {
    const { user: currentUser } = useSelector((state) => state.auth);	
    return (
        <LandingContainer>
            <LandingHeader>
                <img src="../logo192.png" style={{height:"110px",width:'100px', margin:"1rem"}}/>								
                <FadeIn>
                    <h4>Introducing Our Kitchen Designer</h4>
                </FadeIn>
                <FadeIn className="delay-1">
                    <p>
                        The fastest way for dealers to design, quote, and sell custom kitchens.
                    </p>
                </FadeIn>        
                <div style={{display:'flex',flexDirection:'row',gap:'10px',justifyContent:'center',alignItems:'center'}} >
                    <Link to={currentUser?"/viewuserprofile/" + currentUser.id:"/login"} className="mr-2 btn btn-primary lg-2">
                        Try it Now!
                    </Link>         

                    <a className="mr-2 btn btn-success lg-2" target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/watch?v=0zBnjCi6Cck&list=PLupMpToVwrg-vdMf0ARBkvgfP6RlJ7VeX&index=5">
                        See How It Works
                    </a>                       
                </div> 
                                   
            </LandingHeader>
            <Carousel />
            <FeaturesSection className="features">
                <FadeIn className="delay-2">
                    <div>
                        <h2>Key Features:</h2>
                        <ul>
                            <li>⚡ Instant visual kitchen designs</li>
                            <li>💡 Automatic, accurate quoting</li>
                            <li>🛠️ Tailored for cabinet dealers</li>
                            <li>📈 Boost sales and efficiency</li>
                        </ul>                    
                    </div>   
                    <div>
                    </div>             
                </FadeIn>
            </FeaturesSection>
            <LandingFooter>
                <FadeIn className="delay-3">
                    &copy; {new Date().getFullYear()} Cabinets. All rights reserved.
                </FadeIn>
            </LandingFooter>
        </LandingContainer>
    );
}